/*
 * Copyright (c) CIRROM 2022.
 */

import { API } from "./api";

export interface AccountEnrichmentData {
  account_id: string;
  company_name: string;
  cirrom_id: number;
  sic_code: number;
  sic_code_description: string;
}

export const getAccountEnrichmentForSystemId = async (
  integratedSystemId: number,
  groupMode: string,
  includeOrphanAccounts: boolean,
  uniqueCirromIdOnly: boolean,
  uniqueSICOnly: boolean,
  multiGroupsOnly: boolean
): Promise<AccountEnrichmentData[]> => {
  const response = await API.get("/get-account-enrichment-data", {
    params: {
      integrated_system_id: integratedSystemId,
      group_mode: groupMode,
      include_orphans: includeOrphanAccounts,
      unique_entries_only: uniqueCirromIdOnly,
      single_sic_code_only: uniqueSICOnly,
      multi_entry_groups_only: multiGroupsOnly,
    },
  });
  return response.data;
};

export const getAccountUrl = async (
  integratedSystemId: number,
  accountId: string
): Promise<any> => {
  const response = await API.get("/get-account-url", {
    params: { integrated_system_id: integratedSystemId, account_id: accountId },
  });
  return response.data;
};

export const refreshCodes = async (): Promise<any> => {
  const response = await API.post("/refresh_sic_codes");
  return response.data;
};

export const writeAccountEnrichments = async (
  systemId: number,
  accountSics: any
): Promise<any> => {
  const response = await API.post("/write-enrichment-for-account", {
    integrated_system_id: systemId,
    account_sics: accountSics,
  });
  return response.data;
};
